import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext.jsx';

export function ProtectedRoute({ children, groups }) {
  const { user, hasAnyGroup } = useAuth();

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (groups && groups.length > 0 && !hasAnyGroup(groups)) {
    // Redirect based on user's actual group
    if (user.groups.includes('broker')) {
      return <Navigate to="/broker" replace />;
    }
    if (user.groups.includes('leadership')) {
      return <Navigate to="/leadership" replace />;
    }
    return <Navigate to="/" replace />;
  }

  return children;
}
